import { ProcessDraftAssignmentSchema } from '../../entities/process-draft';
/**
 * POST /api/v2/process/:id/draft/assignments/:stableStepId/restore
 * Recreate a draft assignment from a client-held snapshot. Used by undo of
 * `DELETE /.../assignments/:stableStepId` — client snapshots the assignment
 * before delete, then replays that snapshot here.
 *
 * `stableStepId` is in the URL (must match the deleted node so upstream /
 * downstream `sourceSteps.stepId` references remain valid).
 *
 * The response envelope carries the restored assignment plus any upstream
 * nodes whose successors were recomputed.
 */ export const RestoreDraftAssignmentRequestSchema = ProcessDraftAssignmentSchema.pick({
    assignedTo: true,
    assignedToModel: true,
    laneKey: true,
    whoElseDoesThis: true,
    inputs: true,
    helpers: true,
    generatedName: true,
    generatedDescription: true,
    dirtyForInvite: true,
    supersedesAssignment: true,
    stashedStep: true
});

//# sourceMappingURL=restore-draft-assignment.schema.js.map